import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/swiper.css';

// Инициализация Swiper для видео
const videoswiper = new Swiper(".swiper-video", {
  modules: [Navigation],
  loop: true,
  grabCursor: true,
  spaceBetween: 20,
  slidesPerView: 1,
  navigation: {
    nextEl: ".video-next",
    prevEl: ".video-prev",
  },
  breakpoints: {
    768: { slidesPerView: 2 },
    1024: { slidesPerView: 3 },
  },
});

// Инициализация Swiper для статей
const articlesSwiper = new Swiper(".swiper-articles", {
  modules: [Navigation],
  loop: true,
  grabCursor: true,
  spaceBetween: 20,
  slidesPerView: 1,
  navigation: {
    nextEl: ".articles-next",
    prevEl: ".articles-prev",
  },
  breakpoints: {
    768: { slidesPerView: 2 },
    1024: { slidesPerView: 3 },
  },
});

// Табы
document.addEventListener("DOMContentLoaded", () => {
  const tabs = Array.from(document.querySelectorAll(".tab-button"));
  const contents = Array.from(document.querySelectorAll(".tab-content"));

  function removeMatchingClasses(el, prefix) {
    const toRemove = [...el.classList].filter((c) =>
      c.startsWith(prefix)
    );
    toRemove.forEach((c) => el.classList.remove(c));
  }

  function makeActive(tab) {
    tab.setAttribute("aria-selected", "true");
    removeMatchingClasses(tab, "bg-");
    removeMatchingClasses(tab, "text-");

    tab.classList.add(
      "bg-black",
      "text-white",
      "rounded-lg",
      "scale-105",
      "z-10",
      "transition",
      "duration-200",
      "ease-in-out",
      "shadow-md"
    );

    tab.style.color = "#ffffff";
    tab.style.backgroundColor = "#313031";
  }

  function makeInactive(tab) {
    tab.setAttribute("aria-selected", "false");
    removeMatchingClasses(tab, "bg-");
    removeMatchingClasses(tab, "text-");
    removeMatchingClasses(tab, "scale-");
    tab.classList.remove("rounded-lg", "shadow-md", "z-10");

    tab.classList.add(
      "bg-white",
      "text-gray-700",
      "transition",
      "duration-200",
      "ease-in-out"
    );

    tab.style.color = "";
    tab.style.backgroundColor = "";
  }

  function activate(targetId) {
    contents.forEach((c) => c.classList.add("hidden"));
    tabs.forEach(makeInactive);
    const panel = document.getElementById(targetId);
    if (panel) panel.classList.remove("hidden");
    const current = tabs.find((t) => t.dataset.target === targetId);
    if (current) makeActive(current);
  }

  if (tabs.length) {
    tabs[0].classList.add("rounded-l-lg");
    tabs[tabs.length - 1].classList.add("rounded-r-lg");
  }

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => activate(tab.dataset.target));
  });

  const initial =
    tabs.find((t) => t.getAttribute("aria-selected") === "true") ||
    tabs[0];
  if (initial) activate(initial.dataset.target);
});
